// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d7b2afd1","pill":"ec018aa5"};